module.exports = __webpack_public_path__ + "static/media/y.22562795.svg";